import React from "react";
import { useUserLayout } from "./useUserLayout";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileMenu } from "./MobileMenu";
import { foodBg } from "../../../assets/images";

/** Layout pour les utilisateurs connectés. Design unifié, structure modulaire. */
function UserLayout({ children, user, onLogout }) {
  const layout = useUserLayout(onLogout, user);

  return (
    <div className="flex h-screen relative overflow-hidden bg-slate-900">
      {/* Fond fixe sur tout l'écran (image + overlay) pour éviter le "demi-fond" */}
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{ backgroundImage: `url(${foodBg})` }}
        aria-hidden="true"
      />
      <div className="fixed inset-0 bg-slate-900/50 z-0" aria-hidden="true" />

      <Sidebar user={user} {...layout} />
      <div className="flex-1 flex flex-col overflow-hidden relative z-10 min-h-0">
        <Header user={user} {...layout} />
        <MobileMenu
          user={user}
          isOpen={layout.isMobileMenuOpen}
          onClose={() => layout.setIsMobileMenuOpen(false)}
          navItems={layout.navItems}
          menuTitle={layout.menuTitle}
          isActive={layout.isActive}
          handleNavigation={layout.handleNavigation}
          handleLogout={layout.handleLogout}
          t={layout.t}
        />
        <main className="flex-1 overflow-y-auto relative min-h-0">
          <div className="relative max-w-7xl mx-auto p-4 sm:p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default UserLayout;
